import { ChartLineUp } from "@phosphor-icons/react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from "recharts";
import { getTextPrimary, getCardClass } from "../../lib/styleHelpers";

const TICK_DARK = { fontSize: 11, fill: "#6b7280" };
const TICK_LIGHT = { fontSize: 11, fill: "#9ca3af" };
const TOOLTIP_DARK = { background: "#12121a", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", fontSize: "12px", color: "#fff" };
const TOOLTIP_LIGHT = { background: "white", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "12px", color: "#111" };
const BAR_RADIUS = [4, 4, 0, 0];
const PNL_FORMATTER = (value) => [`$${value.toFixed(2)}`, "P&L"];
const TICK_FORMATTER = (v) => `$${v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v}`;

export function PortfolioPnlChart({ data, isDark }) {
  if (!data || data.length === 0) return null;

  const tickStyle = isDark ? TICK_DARK : TICK_LIGHT;
  const tooltipStyle = isDark ? TOOLTIP_DARK : TOOLTIP_LIGHT;
  const gridStroke = isDark ? "#1f1f2e" : "#e2e8f0";
  const axisStroke = isDark ? "#374151" : "#94a3b8";

  return (
    <div className={`rounded-xl p-6 border ${getCardClass(isDark)}`} data-testid="pnl-chart">
      <h3 className={`font-bold mb-4 flex items-center gap-2 ${getTextPrimary(isDark)}`}>
        <ChartLineUp size={20} className="text-purple-500" />
        P&L by Investment
      </h3>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke={gridStroke} />
            <XAxis dataKey="name" tick={tickStyle} stroke={axisStroke} />
            <YAxis tick={tickStyle} stroke={axisStroke} tickFormatter={TICK_FORMATTER} />
            <Tooltip contentStyle={tooltipStyle} formatter={PNL_FORMATTER} />
            <Bar dataKey="pnl" radius={BAR_RADIUS}>
              {data.map((entry) => (
                <Cell key={entry.name} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
